import React, { useState } from "react";
import { AddTreeStructureEditable } from "./AddTreeStructureEditable";
import {
  getValues,
  shouldIncludePenaltyBasedOnYOS,
  withdrawalTypeEnum,
} from "./DistributionConstantsAndFunctions";

export const SummaryComponent = (props) => {
  const {
    values,
    setValues,
    setFieldValue,
    fields,
    requestedAmountEffective,
    grossAmountEffective,
    outerValues,
    employeePlanDetails,
    filteredSourceBalances,
    selectedWithdrawalPlanSetUp,
  } = props;
  return (
    <div className="summary-component">
      <div className="heading-text mb-3">Summary</div>
      <div
        style={{ whiteSpace: "nowrap", marginRight: "10px" }}
        className="heading-text2"
      >
        Allocation Amount{" "}
        <div className="ml-auto">
          {getValues(requestedAmountEffective).toFixed(2)}
        </div>
      </div>
      <hr />
      <AddTreeStructureEditable
        {...props}
        grossAmountEffective={grossAmountEffective}
        requestedAmountEffective={requestedAmountEffective}
        // shouldDisplayPenalty={[
        //   withdrawalTypeEnum.Hardship,
        // ].includes(outerValues?.withdrawalType) || withdrawalTypeEnum.Inservice && (employeePlanDetails?.employeePlanYOS < selectedWithdrawalPlanSetUp.planYOS || (outerValues.ageInYears < selectedWithdrawalPlanSetUp.years && outerValues.ageInMonths < selectedWithdrawalPlanSetUp.months))}
        shouldDisplayPenalty={
          [withdrawalTypeEnum.Hardship].includes(outerValues?.withdrawalType) ||
          (withdrawalTypeEnum.Inservice === outerValues?.withdrawalType &&
            shouldIncludePenaltyBasedOnYOS(
              employeePlanDetails?.employeePlanYOS,
              selectedWithdrawalPlanSetUp,
              outerValues
            ))
        }
      />
      <div
        style={{ whiteSpace: "nowrap", marginRight: "10px" }}
        className="heading-text2 bg-white"
      >
        Gross Withdrawal{" "}
        <div className="ml-auto">
          {getValues(grossAmountEffective).toFixed(2)}
        </div>
      </div>
    </div>
  );
};
